import { render, staticRenderFns } from "./largesScreen.vue?vue&type=template&id=3604e2fc&scoped=true"
import script from "./largesScreen.vue?vue&type=script&lang=js"
export * from "./largesScreen.vue?vue&type=script&lang=js"
import style0 from "./largesScreen.vue?vue&type=style&index=0&id=3604e2fc&prod&lang=css"
import style1 from "./largesScreen.vue?vue&type=style&index=1&id=3604e2fc&prod&lang=scss&scoped=true"
import style2 from "./largesScreen.vue?vue&type=style&index=2&id=3604e2fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3604e2fc",
  null
  
)

export default component.exports